"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConstantsAPI = void 0;
class DefaultConstantsAPI {
    constructor(api) {
        this.api = api;
    }
    getSystemBlockHashCount() {
        return this.api.consts.system.blockHashCount;
    }
    getSystemDbWeight() {
        return this.api.consts.system.dbWeight;
    }
    getTimestampMinimumPeriod() {
        return this.api.consts.timestamp.minimumPeriod;
    }
    getTransactionWeightToFee() {
        return this.api.consts.transactionPayment.weightToFee;
    }
}
exports.DefaultConstantsAPI = DefaultConstantsAPI;
//# sourceMappingURL=constants.js.map